// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import ResearchCardGroup from "./com/ResearchCardGroup";

// Data / Images / Icons

function P_Research() {
  return (
    <DefaultLayout>
      <TitleBar />

      <ResearchCardGroup />
    </DefaultLayout>
  );
}

export default P_Research;
